import { actions, createAction, props } from '@ngneat/effects';
import { IUpdateSessionJobDatasetRequest } from '@data/session-job-dataset/session-job-dataset.model';

export namespace SessionJobDatasetActions {
  export const loadById = createAction(
    '[SessionJobDataset] Load session data by id',
    props<{
      id?: string;
      usePublic?: boolean;
    }>(),
  );

  export const update = createAction(
    '[SessionJobDataset] Update session job dataset',
    props<{ id: string; changes: Partial<IUpdateSessionJobDatasetRequest> }>(),
  );

  export const create = createAction(
    '[SessionJobDataset] Create session job dataset',
    props<{ data: Partial<IUpdateSessionJobDatasetRequest> }>(),
  );

  export const loadDatasetById = (datasetId?: string, usePublic?: boolean): void => {
    actions.dispatch(SessionJobDatasetActions.loadById({ id: datasetId, usePublic }));
  };

  export const updateDataset = (
    _id: string,
    data: Partial<IUpdateSessionJobDatasetRequest>,
  ): void => {
    actions.dispatch(SessionJobDatasetActions.update({ changes: data, id: _id }));
  };

  export const createDataset = (
    _id: string,
    data: Partial<IUpdateSessionJobDatasetRequest>,
  ): void => {
    actions.dispatch(SessionJobDatasetActions.create({ data }));
  };
}
